import { Popover, PopoverTrigger, PopoverContent, Button } from '@heroui/react';
import { FC, useState } from 'react';
import { IoHome } from 'react-icons/io5';
import MsiBrandLogo from '../../../assets/images/seascape_logo.svg';
import HorizonLogoWhite from '../../../assets/images/horizon_logo_white.svg';
import HorizonLogo from '../../../assets/images/horizon_logo.svg';

interface BrandLogoProps {
	horizonUrl?: string;
	isUserSubscribedToHorizon: boolean;
}

const BrandLogo: FC<BrandLogoProps> = ({
	horizonUrl = window.config?.HORIZON_APP_URL || 'https://horizon.msiltd.com',
	isUserSubscribedToHorizon,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [horizonHovered, setHorizonHovered] = useState(false);

	const handleHomeClick = () => {
		window.location.href = '/';
	};

	const handleHorizonNavigation = () => {
		if (isUserSubscribedToHorizon && horizonUrl) {
			window.location.href = horizonUrl;
		}
	};

	// If user doesn't have Horizon subscription, just show clickable return to home logo
	if (!isUserSubscribedToHorizon) {
		return (
			<div className="cursor-pointer align-middle transition-all duration-200 hover:scale-95 inline-block" onClick={handleHomeClick}>
				<img src={MsiBrandLogo} className="py-1 h-12 md:h-[58px] xl:h-[58px] w-auto block" alt="MSI SEASCAPE" />
			</div>
		);
	}

	// If user has Horizon subscription, show hover popup
	return (
		<Popover
			isOpen={isOpen}
			onOpenChange={setIsOpen}
			placement="bottom-start"
			offset={0}
			showArrow={false}
			classNames={{
				base: 'border border-default-200 bg-gradient-to-br from-white to-default-50',
				arrow: 'bg-default-200',
			}}
		>
			<PopoverTrigger>
				<div className="cursor-pointer align-middle inline-block">
					<img
						onMouseEnter={() => setIsOpen(true)}
						onMouseLeave={() => setIsOpen(false)}
						src={MsiBrandLogo}
						className="py-1 h-12 md:h-[58px] xl:h-[58px] w-auto block"
						alt="MSI SEASCAPE"
					/>
				</div>
			</PopoverTrigger>

			<PopoverContent
				className="w-auto p-1 rounded-none"
				onMouseEnter={() => setIsOpen(true)}
				onMouseLeave={() => setIsOpen(false)}
			>
				<div className="flex flex-row justify-start between gap-1">
					{/* Left Box - Refresh */}
					<div className="flex">
						<Button
							className="w-16 h-16 flex-col gap-1 text-white hover:text-[#569fd3e6]  bg-[#569fd3e6]! hover:bg-white! rounded border-1 border-[#569fd3e6] hover:border-gray-200 transition-all duration-200"
							variant="light"	
							title="Return to MSI Seascape Homepage"						
							onPress={handleHomeClick}
						>
							<IoHome size={36} className="" />
							{/* <span className="text-sm font-semibold">Refresh</span> */}
						</Button>
					</div>

					{/* Right Box - Horizon */}
					<div className="flex">
						<Button
							className={`w-auto h-16 flex-col gap-1 border-1 transition-all duration-200 rounded ${
								horizonHovered ? 'bg-white border-gray-300' : 'border-transparent'
							}`}
							style={{
								backgroundColor: horizonHovered ? 'white' : '#569fd3e6',
							}}
							variant="light"
							onPress={handleHorizonNavigation}
							onMouseEnter={() => setHorizonHovered(true)}
							onMouseLeave={() => setHorizonHovered(false)}
						>
							<img src={horizonHovered ? HorizonLogo : HorizonLogoWhite} alt="Horizon" className="w-32 h-16 scale-115" />
						</Button>
					</div>
				</div>
			</PopoverContent>
		</Popover>
	);
};

export default BrandLogo;
